<template>
  <el-cascader v-model="selectValue"
               filterable
               popper-class="data-grid-meta-cascader"
               :options="filterOptions"
               :props="cascaderProps"
               v-bind="$attrs"
               v-on="$listeners">
    <template #default="{data}">
      <div class="custom-node">
        <div class="label">{{data[labelProp]}}</div>
        <div v-if="data[statusProp]"
             class="extra">
          <el-tag size="mini"
                  type="primary">{{data[statusProp]}}</el-tag>
        </div>
      </div>
    </template>
  </el-cascader>
</template>

<script>
export default {
  name: 'DataGridMetaCascader',
  props: {
    value: {
      required: true
    },
    labelProp: {
      type: String,
      default: 'label'
    },
    valueProp: {
      type: String,
      default: 'value'
    },
    statusProp: {
      type: String,
      default: 'status'
    },
    childrenProp: {
      type: String,
      default: 'children'
    },
    options: Array
  },
  computed: {
    cascaderProps () {
      return {
        value: this.valueProp,
        label: this.labelProp,
        children: this.childrenProp,
        emitPath: false
      }
    },
    filterOptions: function () {
      return this.options || []
    },
    selectValue: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>

<style lang="scss">
.data-grid-meta-cascader {
  .custom-node {
    display: flex;
    justify-content: space-between;
    align-items: center;
    &>.extra {
      margin-left: 15px;
    }
  }
}
</style>
